import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

/**
 * Charge un fichier de traduction depuis `/assets/locale/{lang}.json`.
 *
 * @remarks
 * Chargement **à la demande**, contrairement au `require()` de KeepControlWeb.Front qui empaquette
 * les quatre fichiers dans le bundle : ici seules la langue active et le français de repli sont
 * téléchargés.
 *
 * Un fichier absent ou illisible ne doit pas faire échouer le démarrage : la langue est alors
 * simplement vide et ngx-translate retombe clé par clé sur le français.
 */
@Injectable({ providedIn: 'root' })
export class KcTranslateLoader implements TranslateLoader {
  private readonly http = inject(HttpClient);

  /** @inheritdoc */
  public getTranslation(lang: string): Observable<TranslationObject> {
    return this.http.get<TranslationObject>(`assets/locale/${lang}.json`).pipe(
      catchError(() => {
        console.error(`Fichier de traduction introuvable : assets/locale/${lang}.json`);
        return of({} as TranslationObject);
      }),
    );
  }
}
